"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactEbiSpecies = _interopRequireDefault(require("@ebi-gene-expression-group/react-ebi-species"));
var _renderContentListItems = _interopRequireDefault(require("./renderContentListItems"));
var _modelPropTypes = _interopRequireDefault(require("./modelPropTypes"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var MAX_VISIBLE_ITEMS = 5;
var CardContentList = _styledComponents["default"].ul(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  list-style: none;\n  width: 80%;\n  margin-left: auto;\n  margin-right: auto;\n"])));
var ExtendableCard = /*#__PURE__*/function (_React$Component) {
  function ExtendableCard(props) {
    var _this;
    _classCallCheck(this, ExtendableCard);
    _this = _callSuper(this, ExtendableCard, [props]);
    _this.state = {
      isHidden: _this.props.content && _this.props.content.length > MAX_VISIBLE_ITEMS
    };
    _this.onClick = _this.onClick.bind(_this);
    return _this;
  }
  _inherits(ExtendableCard, _React$Component);
  return _createClass(ExtendableCard, [{
    key: "onClick",
    value: function onClick() {
      this.setState({
        isHidden: !this.state.isHidden
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        speciesIconHeight = _this$props.speciesIconHeight,
        imageIconHeight = _this$props.imageIconHeight,
        iconType = _this$props.iconType,
        iconSrc = _this$props.iconSrc,
        description = _this$props.description,
        content = _this$props.content;
      var visibleContent = Array.isArray(content) && (0, _renderContentListItems["default"])(content);
      var cardHero = iconType === "species" ? /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontSize: speciesIconHeight
        }
      }, /*#__PURE__*/_react["default"].createElement(_reactEbiSpecies["default"], {
        species: iconSrc
      })) :
      /*#__PURE__*/
      // iconType === `image` ?  // Margin picked by trial and error to match EbiSpeciesIcon of size 8rem
      _react["default"].createElement("img", {
        src: iconSrc,
        style: {
          height: imageIconHeight,
          marginBottom: "2.35rem",
          marginTop: "2.50rem"
        }
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        style: {
          marginBottom: 0,
          paddingBottom: "2rem",
          textAlign: "center"
        }
      }, description && (description.url ? /*#__PURE__*/_react["default"].createElement("h4", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: description.url
      }, description.text)) : /*#__PURE__*/_react["default"].createElement("h4", null, description.text)), description && (description.url ? /*#__PURE__*/_react["default"].createElement("a", {
        href: description.url,
        style: {
          borderBottom: 0
        }
      }, cardHero) : cardHero), /*#__PURE__*/_react["default"].createElement(CardContentList, {
        className: "content"
      }, this.state.isHidden ? visibleContent.slice(0, MAX_VISIBLE_ITEMS) : visibleContent), Array.isArray(content) && content.length > MAX_VISIBLE_ITEMS && /*#__PURE__*/_react["default"].createElement("button", {
        className: "button",
        onClick: this.onClick
      }, this.state.isHidden ? "Show all" : "Show fewer"));
    }
  }]);
}(_react["default"].Component);
ExtendableCard.propTypes = _objectSpread(_objectSpread({}, _modelPropTypes["default"]), {}, {
  speciesIconHeight: _propTypes["default"].string,
  imageIconHeight: _propTypes["default"].string
});
ExtendableCard.defaultProps = {
  speciesIconHeight: "8rem",
  imageIconHeight: "8rem"
};
var _default = exports["default"] = ExtendableCard;